import React, { useEffect, useState } from "react";
import { auth } from "../../config/firebase";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import "./AdminDashboard.css";
import { ALLOWED_EMAILS } from "../../config/admins";

import DashboardTab from "./Tabs/DashboardTab";
import EventsTab from "./Tabs/EventsTab";
import ChaptersTab from "./Tabs/ChaptersTab";

function AdminDashboard() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("events");
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (currentUser) => {
      if (currentUser && ALLOWED_EMAILS.includes(currentUser.email)) {
        setUser(currentUser);
      } else {
        navigate("/admin");
      }
      setLoading(false);
    });
    return () => unsubscribeAuth();
  }, [navigate]);

  const handleLogout = async () => {
    await signOut(auth);
    navigate("/admin");
  };

  if (loading)
    return (
      <div
        className="admin-full-container"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        Chargement...
      </div>
    );
  if (!user) return null;

  return (
    <div className="admin-full-container">
      <header className="admin-header">
        <h2 style={{ margin: 0 }}>
          AceFund <span style={{ color: "#00f0ff" }}>Admin</span>
        </h2>

        <nav className="admin-nav">
          <button
            className={`tab-btn ${activeTab === "dashboard" ? "active" : ""}`}
            onClick={() => setActiveTab("dashboard")}
          >
            Dashboard
          </button>
          <button
            className={`tab-btn ${activeTab === "events" ? "active" : ""}`}
            onClick={() => setActiveTab("events")}
          >
            Événements
          </button>
          <button
            className={`tab-btn ${activeTab === "chapters" ? "active" : ""}`}
            onClick={() => setActiveTab("chapters")}
          >
            Chapters
          </button>
        </nav>

        <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <span style={{ fontSize: "0.8rem", color: "#888" }}>
            {user.email}
          </span>
          <button
            onClick={handleLogout}
            style={{
              padding: "8px 15px",
              background: "transparent",
              border: "1px solid #ff3366",
              color: "#ff3366",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Quitter
          </button>
        </div>
      </header>

      <main className="admin-content">
        {activeTab === "dashboard" && <DashboardTab />}
        {activeTab === "events" && <EventsTab />}
        {activeTab === "chapters" && <ChaptersTab />}
      </main>
    </div>
  );
}

export default AdminDashboard;
